import { axiosInstanceWithAuth } from '../../../../services/axios-instance';

export const AveragePrice = {
  getPrices: async (modelid: number) => {
    try {
      const res = await axiosInstanceWithAuth.get(`/advertisement/findPriceAverage/${modelid}`);
      return res.data;
    } catch (err: any) {
      return console.error(err.response);
    }
  },
};
